import { useState } from "react";
import { FAQS, VERIFICATION_FAQS } from "../data/content";
import { SectionHeader, CTABand } from "./Home";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Search } from "lucide-react";

const ALL_FAQS = [...VERIFICATION_FAQS, ...FAQS.filter((f) => !VERIFICATION_FAQS.some((v) => v.q === f.q))];

export default function FAQsPage() {
  const [query, setQuery] = useState("");
  const filtered = ALL_FAQS.filter(
    (f) => f.q.toLowerCase().includes(query.toLowerCase()) || f.a.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div data-testid="faqs-page">
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <SectionHeader
            eyebrow="Frequently Asked Questions"
            title="Everything you need to know."
            sub="Straight answers about property verification, timelines, documents, pricing, and how we work."
            className="mb-12"
          />
          <div className="relative mb-12">
            <Search size={18} strokeWidth={1.25} className="absolute left-0 top-1/2 -translate-y-1/2 text-[#C1A74A]" />
            <input
              data-testid="faq-search-input"
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search questions..."
              className="tt-input !pl-8"
              aria-label="Search FAQs"
            />
          </div>
          {filtered.length === 0 ? (
            <p data-testid="faq-no-results" className="text-sm text-gray-500 font-light">
              No questions match your search. Try a different term or contact us directly.
            </p>
          ) : (
            <Accordion type="single" collapsible className="w-full" data-testid="faqs-accordion">
              {filtered.map((f, i) => (
                <AccordionItem key={f.q} value={`faq-${i}`} className="border-[#113835]/10">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="font-heading text-left text-base font-medium text-[#113835] hover:text-[#C1A74A] hover:no-underline py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-gray-600 font-light leading-relaxed pb-6">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
